







import Vue from "vue";
import { FlatExerciseListDetails } from "@tt-app/utils";
import {
  TerratalkLiveGetterNames,
  TerratalkLiveNamespace
} from "@tt-app/store/terratalkLive/types";

interface Methods {
  emitNextExercise: () => void;
  tryAgain: () => void;
}

interface Computed {
  limitedModeActive: boolean;
  nextExerciseButtonText: string;
  tryAgainButtonText: string;
}

interface Props {
  allCorrect: boolean;
  nextExercise?: FlatExerciseListDetails;
  practiceMode: boolean;
}

export default Vue.extend<any, Methods, Computed, Props>({
  name: "ReviewButtons",

  props: {
    allCorrect: { type: Boolean, default: false },
    nextExercise: { type: Object as () => FlatExerciseListDetails, default: undefined },
    practiceMode: { type: Boolean, default: false }
  },

  computed: {
    nextExerciseButtonText() {
      return this.nextExercise ? "exercise.next" : "exercise.end";
    },

    limitedModeActive() {
      const session = this.$store.getters[
        `${TerratalkLiveNamespace}/${TerratalkLiveGetterNames.ACTIVE_SESSION}`
      ];

      return Boolean(session?.limitedMode?.id);
    },

    tryAgainButtonText() {
      let phrase = "exercise.retry-as-practice";

      if (this.limitedModeActive) {
        phrase = "exercise.try-again";
      } else if (this.allCorrect) {
        phrase = "exercise.retry-as-test";
      }

      return phrase;
    }
  },

  methods: {
    emitNextExercise() {
      this.$emit("nextExercise");
    },

    tryAgain() {
      this.$emit("try-again");
    }
  }
});
